export default function FinalCTA() {
  const openBooking = () => {
    window.open('https://book.squareup.com/appointments/yc3ukarfxsbty9/location/LHRN4K68W4NE0', '_blank');
  };

  return (
    <section className="py-32 bg-gradient-to-br from-red-900 via-red-800 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-2 bg-white transform -skew-y-3"></div>
        <div className="absolute top-20 left-0 w-full h-2 bg-white transform skew-y-3"></div>
        <div className="absolute bottom-20 left-0 w-full h-2 bg-white transform -skew-y-3"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="text-red-300 text-xs tracking-widest font-semibold mb-6 whitespace-nowrap">READY FOR A CHANGE?</div>
        <h2 className="text-6xl md:text-8xl font-bold text-white mb-8 leading-tight">
          Ready For A Fresh Cut?
        </h2>
        <p className="text-2xl text-gray-200 mb-12">
          Walk in today or book your appointment online
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          <button 
            onClick={openBooking}
            className="bg-white text-red-900 px-10 py-5 rounded-lg text-lg font-bold hover:bg-gray-100 transition-all hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            BOOK YOUR APPOINTMENT
          </button>
          <a 
            href="tel:0451279664"
            className="border-2 border-white text-white px-10 py-5 rounded-lg text-lg font-bold hover:bg-white hover:text-red-900 transition-all whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            CALL US NOW
          </a>
        </div>

        {/* Phone */}
        <a 
          href="tel:0451279664"
          className="inline-flex items-center gap-3 text-white text-4xl font-bold hover:text-red-300 transition-colors mb-4"
        >
          <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center">
            <i className="ri-phone-fill text-2xl text-red-900"></i>
          </div>
          0451 279 664
        </a>
        <p className="text-gray-300 text-lg">Call us now</p>
        <p className="text-white text-sm mt-4">Open 7 days a week</p>
      </div>
    </section>
  );
}